<template>
  <div class="value-intro" :data-index="index" ref="section">
    <div class="image-box">
      <img :src="imgPath" alt="" @load="imgLoaded = true" :class="{'loaded': imgLoaded}" lazy draggable="false" ondragstart="return false;" v-if="inViewport">
    </div>
    <div class="content-box" :class="color">
      <div class="video-box">
        <video src="../assets/media/kundenorientierung.mp4" autoplay loop muted playsinline v-if="inViewport && index === 0" @play="videoPlaying = true" :class="{'playing': videoPlaying}" />
        <video src="../assets/media/innovation.mp4" autoplay loop muted playsinline v-if="inViewport && index === 1" @play="videoPlaying = true" :class="{'playing': videoPlaying}" />
        <video src="../assets/media/verlaesslichkeit.mp4" autoplay loop muted playsinline v-if="inViewport && index === 2" @play="videoPlaying = true" :class="{'playing': videoPlaying}" />
        <video src="../assets/media/nachhaltigkeit.mp4" autoplay loop muted playsinline v-if="inViewport && index === 3" @play="videoPlaying = true" :class="{'playing': videoPlaying}" />
      </div>
      <headline :color="color" :kicker="kicker" :headline="title" />
      <p v-html="copy"/>
      <button-link :color="color" label="Artikel lesen" :router-link="route" draggable="false" ondragstart="return false;" />
    </div>
  </div>
</template>

<script>
import Headline from "@/elements/Headline";
import ButtonLink from "@/elements/ButtonLink";
export default {
  name: "ValueIntro",
  components: {ButtonLink, Headline},
  props: {
    video: String,
    image: String,
    kicker: String,
    title: String,
    copy: String,
    index: Number,
    route: {
      type: String,
      default: '/'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      imgPath: require('../assets/images/values/' + this.image),
      imgLoaded: false,
      videoPlaying: false,
      inViewport: false
    }
  },
  methods: {
    checkObserver() {
      if (window["IntersectionObserver"]) {
        this.createObserver();
      } else {
        this.loadImages = true;
      }
    },
    createObserver() {
      const options = {
        root: null,
        threshold: 0
      };
      const observer = new IntersectionObserver(this.handleIntersect, options);
      observer.observe(this.$refs.section);
    },
    handleIntersect(intersection) {
      if (intersection[0].isIntersecting) {
        this.inViewport = true;
      }
    }
  },
  mounted() {
    this.checkObserver();
  }
}
</script>

<style scoped>
  .value-intro {
    position: relative;
    height: 100%;
  }
  .image-box {
    position: relative;
    display: block;
    height: 100%;
    width: calc(120vh);
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0;
    transition: 0.5s linear;
  }
  img.loaded {
    opacity: 1;
  }
  .video-box {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  video {
    position: relative;
    width: 100vh;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    transition: 0.4s linear;
    opacity: 0;
  }
  video.playing {
    opacity: 0.2;
  }
  p {
    position: relative;
  }
  .button {
    margin-top: 20px;
  }
  .value-intro[data-index="0"] {
    background-color: #C7125C;
  }
  .value-intro[data-index="0"] .content-box {
    background-color: #C7125C;
    color: white;
  }
  .value-intro[data-index="1"] {
    background-color: #FCC500;
  }
  .value-intro[data-index="1"] .content-box {
    background-color: #FCC500;
  }
  .value-intro[data-index="2"] {
    background-color: #102D61;
  }
  .value-intro[data-index="2"] .content-box {
    background-color: #102D61;
    color: white;
  }
  .value-intro[data-index="3"] {
    background: linear-gradient(20deg, #B1D995 0%, #3CB2B8 100%);
  }
  .value-intro[data-index="3"] .content-box {
    background: linear-gradient(20deg, #B1D995 0%, #3CB2B8 100%);
  }
  @media(min-width: 768px) {
    .content-box {
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-start;
      right: 20vh;
      top: 0;
      bottom: 0;
      width: 400px;
      padding: 60px 40px;
    }
  }
  @media(min-width: 768px) and (max-width: 999px) {
    .content-box {
      top: auto;
      right: 30px;
    }
    .value-intro[data-index="1"] img, .value-intro[data-index="3"] img {
      transform: scale(-1, 1);
    }
    .value-intro[data-index="1"] .content-box, .value-intro[data-index="3"] .content-box {
      left: 30px;
    }
    .value-intro[data-index="0"] .content-box {
      right: 0;
    }
    .value-intro[data-index="2"] .content-box {
      bottom: auto;
      top: 8%;
    }
    .value-intro[data-index="3"] .content-box {
      left: 0;
      top: 10%;
      bottom: auto;
    }
    video {
      width: 550px;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
    }
  }
  @media(min-width: 1000px) {
    .value-intro[data-index="0"] .content-box {
      top: auto;
      color: white;
      min-height: 60vh;
    }
    .value-intro[data-index="0"] video {
      width: 60vh;
      min-width: 480px;
    }
    .value-intro[data-index="1"] .content-box {
      bottom: 14%;
      top: auto;
      background-color: #FCC500;
    }
    .value-intro[data-index="1"] video {
      width: 86vh;
      left: 20%;
    }
    .value-intro[data-index="2"] .content-box {
      background-color: #102D61;
      bottom: auto;
      min-height: 80%;
      color: white;
      padding-top: 120px;
    }
    .value-intro[data-index="2"] video {
      width: 80vh;
    }
    .value-intro[data-index="3"] .content-box {
      background: linear-gradient(20deg, #B1D995 0%, #3CB2B8 100%);
      right: 25vh;
    }
  }
  @media(max-width: 999px) {
    .image-box {
      width: 100%;
      height: 100vw;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .value-intro[data-index="3"] .content-box {
      padding-bottom: calc(20px + 12vw);
    }
  }
  @media(max-width: 767px) {
    .image-box {
      height: 75vw;
    }
    .content-box {
      position: relative;
      display: block;
      padding: 30px 20px;
    }
  }
  @media(max-width: 767px) and (min-width: 568px) {
    video {
      width: 100%;
    }
  }
</style>